import React from 'react';
import Page from '../../../components/Page';
import PermissionDenied from '../../../components/PermissionDenied';
import { useSelector } from 'react-redux';

const withAdminOnly = Component => props => {
  const profile = useSelector(state => state.auth.profile);
  if (!profile || !profile.is_site_admin) {
    return (
      <Page title="Permission Denied">
        <PermissionDenied/>;
      </Page>
    );
  }
  return <Component {...props} profile={profile}/>;
};

export default withAdminOnly;
